<template>
  <div></div>
</template>

<script>
import router from "@/router";
import liff from "@line/liff";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      storeLiffId: "liffGeneral/liffId",
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      console.log("[AND Entry] ========== Entry.vue init() ==========");
      console.log("[AND Entry] Current URL:", location.href);
      console.log("[AND Entry] LIFF ID (from store):", this.storeLiffId);
      console.log("[AND Entry] LIFF ID (from liff.id):", liff.id);
      console.log("[AND Entry] LIFF isInClient:", liff.isInClient?.());
      console.log("[AND Entry] LIFF isLoggedIn:", liff.isLoggedIn?.());
      console.log("[AND Entry] Route params:", this.$route.params);
      console.log("[AND Entry] Route query:", this.$route.query);

      // 如果 localStorage 有 AND_LIFF_REDIRECT 就轉去那個網址
      if (localStorage.getItem('AND_LIFF_REDIRECT')) {
        const url = localStorage.getItem('AND_LIFF_REDIRECT');

        console.log("[AND Entry] Found AND_LIFF_REDIRECT in localStorage:", url);

        localStorage.removeItem('AND_LIFF_REDIRECT');
        location.href = url;
        return;
      }

      const orgCode = this.$route.params.orgCode

      let params = new URL(location.href).searchParams;

      console.log("[AND Entry] liff.state:", params.get('liff.state'));

      if (params.get('liff.state')) {
        const targetPath = '/' + orgCode + '/liff/proj/abbott-and' + params.get('liff.state');
        console.log("[AND Entry] Redirecting to:", targetPath);
        router.push(targetPath);
      } else {
        console.log("[AND Entry] No liff.state found, staying on current page");
      }
    }
  }
}
</script>
